import React, { useContext, useState } from "react";
import '../styles/contact_us.css';
import axios from "axios";
import { AppContext } from "../contexts/AppContext";

function ContactUs() {
    const { BASE_URL } = useContext(AppContext);
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    hasProduct: false, // New checkbox state
    productName: '',
    productDescription: '',
    productImage: null
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    // Handle checkbox differently
    if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } 
    // Handle file input differently
    else if (type === 'file') {
      setFormData(prevState => ({
        ...prevState,
        [name]: e.target.files[0]
      }));
    }
    else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create FormData object for file uploads
    const submissionData = new FormData();
    
    // Append regular form data
    submissionData.append('name', formData.name);
    submissionData.append('email', formData.email);
    submissionData.append('phone', formData.phone);
    submissionData.append('message', formData.message);
    
    // Append product data if checkbox was checked
    if (formData.hasProduct) {
      submissionData.append('productName', formData.productName);
      submissionData.append('productDescription', formData.productDescription);
      if (formData.productImage) {
        submissionData.append('productImage', formData.productImage);
      }
    }
    
    // Here you would typically send the data to your backend
   

    axios.post(`${BASE_URL}/export_message`,submissionData)
    .then(response => {
      if (response.data && response.data.data) {
        console.log('Form submitted:', Object.fromEntries(submissionData));
        alert('Thank you for your message! We will get back to you soon.');
      } else {
          console.error('Invalid response structure');
      }
  })
  .catch(err => {
      console.error('Error fetching popular categories:', err);
  });
    
    // Reset form after submission
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: '',
      hasProduct: false,
      productName: '',
      productDescription: '',
      productImage: null
    });
  };

  return (
    <>
      {/* ... (keep your existing sections unchanged) ... */}
      
      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="row justify-content-center">
          <div className="col-12 col-md-5"></div>
          <div className="col-12 col-md-5">
            <div className="contact-form-wrapper">
              <h3 className="form-title">Request A Call Back<br/>Let us help you get started!</h3>
              <form onSubmit={handleSubmit} className="contact-form" encType="multipart/form-data">
                {/* Existing form fields */}
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="form-control"
                    placeholder="Enter your name"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-control"
                    placeholder="Enter your email"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="4"
                    className="form-control"
                    placeholder="Message"
                  ></textarea>
                </div>
                
                {/* New checkbox and conditional product fields */}
                {/* <div className="form-group form-check">
                  <input
                    type="checkbox"
                    id="hasProduct"
                    name="hasProduct"
                    checked={formData.hasProduct}
                    onChange={handleChange}
                    className="form-check-input"
                  />
                  <label className="form-check-label" htmlFor="hasProduct">
                    I want to submit a product
                  </label>
                </div> */}
                
                {/* {formData.hasProduct && (
                  <div className="product-fields">
                    <div className="form-group">
                      <label htmlFor="productName">Product Name</label>
                      <input
                        type="text"
                        id="productName"
                        name="productName"
                        value={formData.productName}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter product name"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="productDescription">Product Description</label>
                      <textarea
                        id="productDescription"
                        name="productDescription"
                        value={formData.productDescription}
                        onChange={handleChange}
                        rows="3"
                        className="form-control"
                        placeholder="Enter product description"
                      ></textarea>
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="productImage">Product Image</label>
                      <input
                        type="file"
                        id="productImage"
                        name="productImage"
                        onChange={handleChange}
                        className="form-control"
                        accept="image/*"
                      />
                    </div>
                  </div>
                )} */}
                
                <button type="submit" className="submit-btn">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactUs;